// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping48Filled: FC<Shipping48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m1.1 26.15.75-3h11l-.75 3h-11ZM13.5 40c-1.667 0-3.033-.6-4.1-1.8-1.067-1.2-1.517-2.617-1.35-4.25h-5l1.15-4.8h10.25l1.8-7.3h4.2l2.25-9H8.8l.65-2.5c.167-.7.517-1.267 1.05-1.7A2.849 2.849 0 0 1 12.35 8h23.6L34 16.5h6.25l5.7 7.6L44 33.95h-4c.167 1.633-.292 3.05-1.375 4.25-1.083 1.2-2.458 1.8-4.125 1.8-1.667 0-3.033-.6-4.1-1.8-1.067-1.2-1.517-2.617-1.35-4.25H19c.167 1.633-.292 3.05-1.375 4.25-1.083 1.2-2.458 1.8-4.125 1.8ZM5.1 18.85l.75-3h13l-.75 3h-13ZM13.5 37c.7 0 1.292-.25 1.775-.75.483-.5.725-1.083.725-1.75 0-.7-.242-1.292-.725-1.775C14.792 32.242 14.2 32 13.5 32c-.667 0-1.25.242-1.75.725S11 33.8 11 34.5c0 .667.25 1.25.75 1.75s1.083.75 1.75.75Zm21 0c.7 0 1.292-.25 1.775-.75.483-.5.725-1.083.725-1.75 0-.7-.242-1.292-.725-1.775C35.792 32.242 35.2 32 34.5 32c-.667 0-1.25.242-1.75.725S32 33.8 32 34.5c0 .667.25 1.25.75 1.75s1.083.75 1.75.75Zm-2.8-10.5h10.75l.3-1.65-4-5.35H33.3l-1.6 7Z" />
        </svg>
    );
};

export default Shipping48Filled;
